/** Remembers the last wallet the user connected (by EIP-6963 rdns). All storage access is best-effort. */
export const WALLET_STORAGE_KEY = 'hip4.wallet.rdns';

function storage(): Storage | undefined {
  try {
    return typeof window !== 'undefined' ? window.localStorage : undefined;
  } catch {
    return undefined;
  }
}

export function loadLastWallet(): string | null {
  try {
    return storage()?.getItem(WALLET_STORAGE_KEY) ?? null;
  } catch {
    return null;
  }
}

export function saveLastWallet(rdns: string): void {
  try {
    storage()?.setItem(WALLET_STORAGE_KEY, rdns);
  } catch {
    /* ignore */
  }
}

export function clearLastWallet(): void {
  try {
    storage()?.removeItem(WALLET_STORAGE_KEY);
  } catch {
    /* ignore */
  }
}
